module.exports = __webpack_public_path__ + "static/img/indirect323.41d39a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indirect323.jpg
// module id = Ngb6
// module chunks = 3